import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { FulfillRfidBadgeOrderModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/user-service-lib/src/wrapper/inputs/rfid-badge-orders/fulfill-rfid-badge-order.model';
import React from 'react';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFulfillRfidBadgeOrderContext } from '../../emsp-bo-rfid-badge-order.context';
import { EmspBoRfidBadgeOrderFulfillFormStep1Controller } from '../emsp-bo-rfid-badge-order-fulfill-form-step-1/emsp-bo-rfid-badge-order-fulfill-form-step-1.controller';

interface EmspBoRfidBadgeOrderFulfillFormControllerProps {
  onError: SubmitErrorHandler<FulfillRfidBadgeOrderModel>;
  onSubmit: SubmitHandlerWithDirtyFields<FulfillRfidBadgeOrderModel>;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const EmspBoRfidBadgeOrderFulfillFormController = (
  props: EmspBoRfidBadgeOrderFulfillFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useFulfillRfidBadgeOrderContext();

  return (
    <MultiStepFormProvider<FulfillRfidBadgeOrderModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: ['id', 'rfidBadgeVisualNumbers'],
          component: <EmspBoRfidBadgeOrderFulfillFormStep1Controller />,
        },
      ]}
    />
  );
};
